module.exports = __webpack_public_path__ + "static/img/14.957c204.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/14.png
// module id = elQ1
// module chunks = 0